module.exports = __webpack_public_path__ + "static/edinme-seo-6ec6e2d41574d895fc6a7684ecd8d805.jpg";